import dayjs from "dayjs";
import { ATL_TZ, atl } from "@/lib/format";

export const SERVICE_TYPES = [
  { id: "transfer", label: "City Transfer", short: "City", blurb: "Point-to-point across Atlanta" },
  { id: "airport", label: "Airport", short: "Airport", blurb: "Hartsfield-Jackson transfers" },
  { id: "hourly", label: "Hourly Hire", short: "Hourly", blurb: "A chauffeur at your disposal" },
];

export const SERVICE_LABELS = Object.fromEntries(SERVICE_TYPES.map((s) => [s.id, s.label]));

const pad = (n) => String(n).padStart(2, "0");

export const TIME_SLOTS = [7, 9, 11, 13, 15, 17, 19, 21].map((h) => ({
  hour: h,
  value: `${pad(h)}:00`,
  label: `${h % 12 || 12} ${h < 12 ? "AM" : "PM"}`,
}));

export function dateOptions() {
  const base = atl().startOf("day");
  return Array.from({ length: 6 }, (_, i) => {
    const d = base.add(i, "day");
    const label = i === 0 ? "Today" : i === 1 ? "Tomorrow" : d.format("ddd D");
    return { value: d.format("YYYY-MM-DD"), label };
  });
}

const slotTime = (date, hour) => dayjs.tz(`${date}T${pad(hour)}:00`, ATL_TZ);
export const isSlotPast = (date, hour) => slotTime(date, hour).isBefore(dayjs());
export const toScheduledISO = (date, hour) => slotTime(date, hour).toISOString();

export function firstOpenSlot(date) {
  return TIME_SLOTS.find((s) => !isSlotPast(date, s.hour))?.hour ?? null;
}

export const AIRPORT = {
  address: "Hartsfield-Jackson Atlanta International Airport, Atlanta, GA",
  lat: 33.6407,
  lng: -84.4277,
};

export const PRESETS = [
  { label: "Hartsfield-Jackson Airport (ATL)", ...AIRPORT },
  { label: "The St. Regis Atlanta", address: "The St. Regis Atlanta, 88 West Paces Ferry Rd NW, Atlanta, GA", lat: 33.8418, lng: -84.3815 },
  { label: "Four Seasons Hotel Atlanta", address: "Four Seasons Hotel Atlanta, 75 14th St NE, Atlanta, GA", lat: 33.7866, lng: -84.3846 },
  { label: "Mercedes-Benz Stadium", address: "Mercedes-Benz Stadium, 1 AMB Dr NW, Atlanta, GA", lat: 33.7554, lng: -84.4008 },
  { label: "The Fox Theatre", address: "Fox Theatre, 660 Peachtree St NE, Atlanta, GA", lat: 33.7725, lng: -84.3857 },
];

export const VEHICLE_IMAGES = {
  "luxury-suv": "/images/suv-escalade.jpg",
};

export const BOOKING_PHONE = { display: "678.486.7374", tel: "tel:+16784867374" };
